"use client";

import { Next13ProgressBar } from "next13-progressbar";
import React from "react";
import { ToastContainer } from "react-toastify";

const Provider = ({ children }: { children: React.ReactNode }) => {
    return (
        <>
            {children}
            <ToastContainer
                position="bottom-left" // موقعیت نمایش پیش‌فرض
                autoClose={5000} // مدت زمان نمایش
                hideProgressBar={false} // نمایش Progress Bar
                newestOnTop={true} // نمایش جدیدترین پیام در بالا
                closeOnClick={true} // بستن با کلیک
                rtl={false} // راست‌چین یا چپ‌چین
                pauseOnFocusLoss={true} // توقف با از دست رفتن فوکوس
                draggable={true} // قابلیت Drag کردن
                pauseOnHover={true} // توقف با Hover
                theme="colored" // تم رنگی
                style={{
                    zIndex: 9999, // برای اولویت دادن به ToastContainer
                    fontSize: "14px" // تغییر سایز فونت
                    // fontFamily: "Arial, sans-serif" // فونت دلخواه
                }}
            />{" "}
            <Next13ProgressBar
                height="4px"
                color="#22C55E"
                options={{ showSpinner: true }}
                showOnShallow
            />
        </>
    )
}

export default Provider